<template>
  <div>
    <p-contact-technical-sale
      v-if="!isAuthenticated"
      @button-click="login()"
      data-test="logged-out-contact-form"
      :is-authenticated="isAuthenticated"
    ></p-contact-technical-sale>
    <p-contact-technical-sale
      v-else
      @button-click="showContactTCModal()"
      data-test="logged-in-contact-form"
      :is-authenticated="isAuthenticated"
      :cooperative-name="cooperativeName"
    ></p-contact-technical-sale>
    <p-contact-technical-sale-modal
      ref="contactTCModal"
      :contact-list="technicalSales"
      v-if="isAuthenticated"
      data-test="contact-technical-sale-modal"
    ></p-contact-technical-sale-modal>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, type PropType } from 'vue'
import PContactTechnicalSaleModal from '@b2ag/offers/src/presenters/PContactTechnicalSaleModal/PContactTechnicalSaleModal.vue'
import PContactTechnicalSale from '@b2ag/marketing/src/application/presenters/PContactTechnicalSale/PContactTechnicalSale.vue'
import type { TechnicalSale } from '../typings'

export default defineComponent({
  name: 'PProductTechnicalSale',
  components: {
    PContactTechnicalSaleModal,
    PContactTechnicalSale,
  },
  props: {
    cooperativeName: {
      type: String,
      default: '',
    },
    technicalSales: {
      type: Array as PropType<TechnicalSale[]>,
      default: () => [],
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
  },
  setup(_props, { emit }) {
    const contactTCModal = ref<(typeof PContactTechnicalSaleModal & { show: () => void; hide: () => void }) | null>(
      null,
    )
    const login = () => emit('login')
    const showContactTCModal = () => contactTCModal.value?.show()

    return {
      contactTCModal,
      login,
      showContactTCModal,
    }
  },
})
</script>
